// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener('cart:item-added', async function (evt) {
    console.log('Item added to the cart');
    console.log(evt.detail.product);
    const giftQ = [...document.querySelectorAll('[data-gift-quantity]')];
    if (giftQ.length) {
        for (const _q of giftQ) {
            const q = parseInt(_q.querySelector('[data-quantity-input]')?.value);
            if (q > 0) {
                const box = _q.querySelector('[data-gift-box-id]');
                if (box) {
                    if (evt.detail.product === parseInt(box.value)) return;
                    let formData = {
                        'items': [{
                            'id': parseInt(box.value),
                            'quantity': q
                        }]
                    };
                    const { res } = await window.themeCart.addItemById(parseInt(box.value), q, {
                        _product_id: evt.detail.product.product_id,
                        _variant_id: evt.detail.product.variant_id
                    });
                    document.dispatchEvent(new CustomEvent('confirmation-popup:open', {
                        product: res.items[0]
                    }));
                }
            }
        }
    }
});

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener('cart:updated', function (evt) {
    console.log('Cart updated');
    console.log(evt.detail.cart);
    const cart = evt.detail.cart;
    if (cart.items && cart.items.length > 0) {
        for (const item of cart.items) {
            const props = item.properties;
            if (props._product_id && props._variant_id) {
                // This is a gift box, check from related product in the cart
                const relatedProduct = cart.items.find(e => e.product_id === props._product_id);
                if (!relatedProduct) {
                    // No related product, delete this gift box
                    console.log('Deleting gift box from cart');
                    let updates = {
                        'id': item.key,
                        'quantity': 0,
                    };
                    fetch(window.Shopify.routes.root + 'cart/change.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(updates)
                    })
                        .then(response => {
                            return response.json();
                        })
                        .then(res => window.forceRefreshCart(res))
                        .catch((error) => {
                            console.error('Error:', error);
                        });
                } else {
                    // Check the quantities, must be the same
                    if (item.quantity > relatedProduct.quantity) {
                        // adjust cart quantities
                        console.log('Need to adjust quantity', 'Gift box:', item.quantity, 'Related product:', relatedProduct.quantity);
                        let updates = {
                            'id': item.key,
                            'quantity': relatedProduct.quantity,
                        };
                        fetch(window.Shopify.routes.root + 'cart/change.js', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(updates)
                        })
                            .then(response => {
                                // document.getElementById(`quantity-${item.key}`).textContent = relatedProduct.quantity
                                return response.json();
                            })
                            .then(res => window.forceRefreshCart(res))
                            .catch((error) => {
                                console.error('Error:', error);
                            });
                    }
                }
            }
        }
    }
    if (cart.items_removed && cart.items_removed.length > 0) {
        for (const item of cart.items_removed) {
            // fetch(window.Shopify.routes.root + `${item.url.slice(1).split('?')[0]}.js`)
            // .then(response => response.json())
            // .then(product => console.log(product));
        }
    }
});

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener('cart:error', function (evt) {
    console.log('Cart error');
    console.log(evt.detail.errorMessage);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener('quick-cart:open', function (evt) {
    console.log('Quick cart opened');
    console.log(evt.detail.cart);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener('quick-cart:close', function () {
    console.log('Quick cart closed');
});

// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
document.addEventListener('product:variant-change', function (evt) {
    console.log('Product variant changed');
    console.log(evt.detail.variant);
});

// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener('product:quantity-update', function (evt) {
    console.log('Product quantity updated');
    console.log(evt.detail.quantity, evt.detail.variant);
});

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener('quickview:loaded', function () {
    console.log('Quickview loaded');
});
